<template>
 <div class="ueditor-textarea">
        <textarea :id="editorId" placeholder="请输入详细信息" ref="simditaor"></textarea>
        <!-- <script  id="editor" type="text/plain"></script> -->
        <!-- <vue-ueditor-wrap :config="myConfig"></vue-ueditor-wrap> -->
    </div>
</template>
<script>
// 组件class前缀
import '../../../../public/UEditor/ueditor.config'
import '../../../../public/UEditor/ueditor.all'
import '../../../../public/UEditor/lang/zh-cn/zh-cn.js'
import $ from 'jquery'
export default {
  name: 'wt-ueditor',
  props: {
    value: {
      default: function () {
        return ''
      }
    },
    init: {
      type: Function,
      default: function () {
        return () => {}
      }
    },
    // 资源定义名称
    resource: {
      type: String,
      required: true
    },
    // 是否是public资源（目前后端仅支持public资源的路径）
    public: {
      type: Boolean,
      default: true
    },
    initialHeight: {
      type: [Number, String],
      default: ''
    },
    content: {
      default: function () {
        return ''
      }
    }
  },
  data () {
    return {
      ueditor: '',
      editorId: 'editor_' + (Math.random() * 100000000000000000),
      myConfig: {
        autoHeightEnabled: false,
        // 初始容器高度
        initialFrameHeight: this.initialHeight || 600,
        scaleEnabled: false,
        focus: true, // 如果有内容，光标位于内容之后
        maxFrameWidth: '100%',
        // 初始容器宽度
        initialFrameWidth: '100%',
        serverUrl: `${this.$apiServer}/messages/api/ueditor/handler`,
        UEDITOR_HOME_URL: '/UEditor/',
        imageUrlPrefix: this.public ? this.$publicResourcesUrl : this.$privateResourcesUrl,
        'fontfamily': [
          { label: '', name: 'songti', val: '宋体,SimSun' },
          { label: '', name: 'kaiti', val: '楷体,楷体_GB2312, SimKai' },
          { label: '', name: 'yahei', val: '微软雅黑,Microsoft YaHei' },
          { label: '', name: 'heiti', val: '黑体, SimHei' },
          { label: '', name: 'lishu', val: '隶书, SimLi' },
          { label: '', name: 'arial', val: 'arial, helvetica,sans-serif' }
        ],
        toolbars: [[
          'fullscreen', 'source', '|', 'undo', 'redo', '|',
          'bold', 'italic', 'underline', 'fontborder', 'strikethrough', 'superscript', 'subscript', 'removeformat', 'formatmatch', 'autotypeset', 'blockquote', 'pasteplain', '|', 'forecolor', 'backcolor', 'insertorderedlist', 'insertunorderedlist', 'selectall', 'cleardoc', '|',
          'rowspacingtop', 'rowspacingbottom', 'lineheight', '|',
          'customstyle', 'paragraph', 'fontfamily', 'fontsize', '|',
          'directionalityltr', 'directionalityrtl', 'indent', '|',
          'justifyleft', 'justifycenter', 'justifyright', 'justifyjustify', '|', 'touppercase', 'tolowercase', '|',
          'link', 'unlink', 'anchor', '|', 'imagenone', 'imageleft', 'imageright', 'imagecenter', '|',
          'insertimage', 'emotion', 'insertvideo', 'insertiframe', 'music', 'attachment', 'pagebreak', 'template', 'background', '|',
          'horizontal', 'date', 'time', 'spechars', 'snapscreen', 'wordimage', '|',
          'inserttable', 'deletetable', 'insertparagraphbeforetable', 'insertrow', 'deleterow', 'insertcol', 'deletecol', 'mergecells', 'mergeright', 'mergedown', 'splittocells', 'splittorows', 'splittocols', 'charts', '|',
          'print', 'searchreplace', 'help'
        ]],
        'insertorderedlist': {
          'decimal': '',
          'lower-alpha': '',
          'lower-roman': '',
          'upper-alpha': '',
          'upper-roman': ''
        }
      },
      id: ''
    }
  },
  watch: {
    content: {
      handler: function (val) {
        if (this.ueditor) {
          // setContent方法，如果需要在文章顶部加入一个<p>标签，则将第二个参数设置为true
          this.ueditor.setContent(val)
        }
      }
    },
    ueditor () {
      if (this.content && !this.ueditor.getContent()) {
        // setContent方法，如果需要在文章顶部加入一个<p>标签，则将第二个参数设置为true
        this.ueditor.setContent(this.content)
      }
    }
  },
  mounted () {
    const _this = this
    // 请求加cookie
    $.ajaxPrefilter(function (options, originalOptions, jqXHR) {
      options.xhrFields = {
        withCredentials: true
      }
    })
    let ue = window.UE.getEditor(this.editorId, this.myConfig)
    ue.ready(function () {
      // 配置我们后端接口需求的外参数
      ue.execCommand('serverparam', { 'resource': _this.resource })
      ue.execCommand('fontfamily', 'Microsoft YaHei')
      _this.ueditor = ue
      // setContent方法，如果需要在文章顶部加入一个<p>标签，则将第二个参数设置为true
      _this.ueditor.setContent(_this.value)
    })
    ue.addListener('contentChange', function () {
      _this.$emit('input', ue.getContent())
    })
  },
  methods: {
    getUEContent () { // 获取含标签内容方法
      return this.ueditor.getContent()
    }
    // getUEContent: function () {
    //   this.$nextTick(_ => {
    //     console.log('this.editor.getContent()', this.ueditor)
    //   })
    //   return this.ueditor.getContent()
    // }
  },
  created () {
    // console.log('window.UEDITOR_HOME_URL', window.UEDITOR_HOME_URL)
  }
}
</script>
<style lang="less">
.ueditor-textarea{
    .edui-editor{
        z-index:2!important
    }
    .edui-editor-iframeholder{
        height: 100%;

    }
}
</style>
